module.exports = __webpack_public_path__ + "img/usersNewGift.ed95a46b.jpg";